module.exports = __webpack_public_path__ + "img/k23jd_6.prt.99d2a03d.jpg";